import { t } from '@lingui/macro';
import { useApi } from '@prismo-io/core';
import type { SWRArgs } from '@prismo-io/schemas';
import toast from 'react-hot-toast';
import useSWRMutation from 'swr/mutation';
import { deleteFormation } from '../utils/delete-formation';

export function useDeleteFormation() {
  const { client } = useApi();

  return useSWRMutation(
    'delete-quark-formation',
    (key, { arg }: SWRArgs<string>) => {
      return toast.promise(deleteFormation(client, arg), {
        loading: t`Suppression de la formation...`,
        success: t`La formation a bien été supprimée.`,
        error: t`Une erreur est survenue lors de la suppression de la formation.`,
      });
    }
  );
}
